import React from "react";
import { Link } from "react-router-dom";

import { AppRoutes } from "pages/constants/routes";

import styles from "./InitialisingState.module.scss";
import { ReactComponent as FactoryRobot } from "assets/misc/factory_robot.svg";

const InitialisingState = () => {
  return (
    <div className={styles.content}>
      <FactoryRobot className={styles.illustration} />
      <div className={styles.messageBox}>
        <div>
          Your project is still intialising as we are verifying and preparing
          your project for deployment.
        </div>
        <div>Hang on tight and do return when your project is ready!</div>
      </div>
      <Link className={styles.supportButton} to={AppRoutes.support}>
        Contact Us
      </Link>
    </div>
  );
};

export default InitialisingState;
